module.exports = __webpack_public_path__ + "assets/img/star_sentence2.6e4b2d4a.png";